
/** @format */

import React, { useState, useEffect } from 'react';
import {
  PageContainer,
  PaginationComponenets,
  Empty,
  Icons
} from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { Grid, Button } from '@mui/material';
import InitFilters from './constants/InitFiltering';
import Services from './services/ReceivedSubscriptionsServices';
import { generateData } from './components/Columns';
import ReceivedSubscriptionItem from './components/ReceivedSubscriptionItem';
import { useStyles } from './style';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import {useCurrencyUnit} from 'hooks';

const AssignedDelegation = () => {
  // -- STATES --//
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [totalCount, setTotoalCount] = useState(0);
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState(InitFilters);
  const [data, setData] = useState([]);
  const currencyText = useCurrencyUnit(false);
  
  // --HOOKS--//
  const actionsList =
    getDynamicObjectAction([
      'subScriptionServicePage',
    ])

  useEffect(() => {

    if (actionsList['subScriptionServicePage']) {
      getList({ page: currentPage === 1 ? 0 : currentPage - 1, pageSize: 6 });
      paginationOnChange({
        page: currentPage === 1 ? 0 : currentPage,
        pageSize: 6,
        pageNumber: currentPage === 0 ? 0 : currentPage - 1,
        changeData: true,
      });
    }

  }, [currentPage]);

  const getList = async (query) => {

    try {
      setLoading(true);

      // TODO: Handle Order By (is not provided by server side)
      const orderBy = [];
      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      const params = {
        offset: query ? query?.page * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,

        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await Services.getSubscriptions(params);
      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query?.page,
          pageSize: query?.pageSize,
        });
      }
      setTotoalCount(res?.count)

      setLoading(false);

      setData(list);
      const d = {
        data: list,
        page: query?.page,
        totalCount: res?.count,
      };

      return d; // passed to MaterialTable
    } catch (error) {
      setLoading(false);
    }
  };
  const onhandleRefresh = () => {
    getList({ page: currentPage - 1, pageSize: 6 });
  };

  const hint =
    'در این بخش می‌توانید لیست درخواست‌های فعالسازی طرح‌های اشتراک خود (طرح‌هایی که خریداری کرده‌اید) را مشاهده کنید. وضعیت هر درخواست در ستون مربوطه نمایش داده شده است.';

  const paginationOnChange = async (param) => {
    if (param?.changeData) {
      // صفحه جاری در این بخش ست میش
      setCurrentPage(param?.page == 0 ? 1 : param?.page);
    }
  };
  return (
    <PageContainer
      title="طرح‌های فعال"
      breadcrumbs={constBreadCrumbsTitle.SUBSCRIPTIONS_RECEIVED}
      className={classes.root}
      loading={loading}
    >
      {actionsList['subScriptionServicePage'] && (
        <>
          <Grid container spacing={2}>
            {data?.length > 0 ? (data.map((data, index) => (
              <Grid item xs={12} md={6} lg={4}>
                <ReceivedSubscriptionItem data={data} onhandleRefresh={onhandleRefresh} currencyText={currencyText} />
              </Grid>
            ))) : (
              <Empty label="لیست طرح‌های فعال خالی است!" />
            )}
          </Grid>

          {data?.length > 0 ? (<Grid justifyContent="center" container style={{ marginTop: 16 }}>


            <PaginationComponenets
              itemsPerPage={6}
              currentPage={currentPage}
              pageCount={totalCount}
              onChange={paginationOnChange}
              removePrePage={true}
            />

          </Grid>) : ('')}



        </>
      )}

    </PageContainer>
  );
};

// See detail for every row
const SeeDetailBtn = ({ expanded }) => {
  const classes = useStyles();

  return (
    <Button
      startIcon={!expanded ? <Icons icon="CaretDown" color="#303d8f" size="25" /> : <Icons icon="CaretUp" color="#303d8f" size="25" />}
      variant="contained"
      className={classes.expandBtn}
      onClick={() => { }}
    >
      {expanded ? 'بستن' : 'جزئیات'}
    </Button>
  );
};

export default AssignedDelegation;
